(() => {
  if (window.veranelleReviewScore) { window.veranelleReviewScore(); return; }
  const cache = new Map();
  const svgNS = 'http://www.w3.org/2000/svg';
  const path = 'M12 2.75l2.78 5.63 6.22.9-4.5 4.39 1.06 6.2L12 16.94 6.44 19.87l1.06-6.2L3 9.28l6.22-.9L12 2.75z';
  function init() {
    document.querySelectorAll('[data-note-avis]:not([data-pret])').forEach(link => {
      link.dataset.pret = 'true';
      const url = link.dataset.resume;
      if (!cache.has(url)) cache.set(url, fetch(url, { credentials:'omit' }).then(r => {
        if (!r.ok) throw new Error('Résumé indisponible');
        return r.json();
      }));
      cache.get(url).then(({ moyenne, total }) => {
        if (!Number.isFinite(moyenne) || !Number.isFinite(total)) throw new Error('Résumé invalide');
        const score = moyenne.toLocaleString('fr-FR');
        const count = total.toLocaleString('fr-FR');
        link.querySelector('[data-note-chiffre]').textContent = score;
        const countEl = link.querySelector('[data-note-total]');
        if (countEl) countEl.textContent = count;
        link.setAttribute('aria-label', score + ' sur 5 dans le corpus capillaire, ' + count + ' avis — consulter les avis et leur provenance');
        const box = link.querySelector('[data-note-etoiles]');
        box.replaceChildren();
        const visualScore = Math.round(moyenne * 2) / 2;
        for (let i = 0; i < 5; i++) {
          const svg = document.createElementNS(svgNS,'svg');
          svg.setAttribute('viewBox','0 0 24 24');
          const outline = document.createElementNS(svgNS,'path');
          outline.setAttribute('d',path);
          svg.append(outline);
          const fill = document.createElementNS(svgNS,'path');
          fill.setAttribute('d',path);
          fill.style.fill = 'currentColor';
          fill.style.clipPath = 'inset(0 ' + (100 - Math.max(0,Math.min(1,visualScore-i))*100) + '% 0 0)';
          svg.append(fill);
          box.append(svg);
        }
      }).catch(() => { link.textContent='Consulter les avis capillaires'; });
    });
  }
  window.veranelleReviewScore = init;
  init();
  document.addEventListener('shopify:section:load',init);
})();
